const CONSTANTSSTRINGS = {
	INDIVIDUAL: "individual",
	CORPORATE: "corporate",
};

const ACCOUNTTYPES = [CONSTANTSSTRINGS.INDIVIDUAL, CONSTANTSSTRINGS.CORPORATE];

const GENDER = ["male", "female"];

const TITLES = ["mr", "miss", "mrs", "ms.", "dr.", "engr.", "chief", "sir"];

const IDENTITYTYPES = [
	"INTERNATIONAL PASSPORT",
	"DRIVERS LICENSE",
	"VOTERS CARD",
	"Others",
];

const constantStrings = {
	ABUJA: "Abuja (FCT.)",
};

const stateIdMap = {
	Abia: "AB",
	[constantStrings.Abuja]: "FC",
	Adamawa: "AD",
	"Akwa Ibom": "AK",
	Anambra: "AN",
	Bauchi: "BA",
	Bayelsa: "BY",
	Benue: "BE",
	Borno: "BO",
	"Cross River": "CR",
	Delta: "DE",
	Ebonyi: "EB",
	Edo: "ED",
	Ekiti: "EK",
	Enugu: "EN",
	Gombe: "GO",
	Imo: "IM",
	Jigawa: "JI",
	Kaduna: "KD",
	Kano: "KN",
	Katsina: "KT",
	Kebbi: "KE",
	Kogi: "KO",
	Kwara: "KW",
	Lagos: "LA",
	Nassarawa: "NA",
	Niger: "NI",
	Ogun: "OG",
	Ondo: "ON",
	Osun: "OS",
	Oyo: "OY",
	Plateau: "PL",
	Rivers: "RI",
	Sokoto: "SO",
	Taraba: "TA",
	Yobe: "YO",
	Zamfara: "ZA",
};

const adminRoles = [
	{ name: "Initiator", value: "initiator" },
	{ name: "Authorizer", value: "authorizer" },
];

const statusColors = {
	submitted: "#bf7bb5",
	processing: "#ef9011",
	approved: "#528DC2",
	rejected: "#e61c23",
	deleting: "#e61c23",
};

const initiatorStatuses = ["submitted", "processing", "approved", "rejected"];

const authorizerStatuses = ["processing", "approved", "rejected", "deleting"];

const REQUESTREJECTIONREASONS = [
	"Irregular Signature",
	"Signature Differs/Incorrect Signature",
	"Signature not Available, Process transfer form",
	"Bad Image",
	"Name Differs",
	"Name not Found, Evidence of purchase required",
	"Name Differs, Change of Name required",
	"Incorrect Details (Kindly supply Correct Details)",
	"Expired ID Card",
	"Transmission of Share Required",
	"Account Cautioned (Shareholder's Attention Required)",
	"Second Signatory not on our Records",
	"Specify any other reason",
];

const emailRegex =
	/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export {
	ACCOUNTTYPES,
	CONSTANTSSTRINGS,
	TITLES,
	GENDER,
	IDENTITYTYPES,
	stateIdMap,
	adminRoles,
	statusColors,
	REQUESTREJECTIONREASONS,
	emailRegex,
	initiatorStatuses,
	authorizerStatuses,
};
